import type { Color } from "../types/colors/Color"
import type { RGBColor } from "../types/colors/RGBColor"
import { CmykToRgb } from "./CmykToRgb"
import { HslToRgb } from "./HslToRgb"

/**
 * Converts a Color to an RGBColor
 * If the input is already RGB, it will be returned as is
 * If the input is CMYK or HSL, it will be converted to RGB
 */
export const ToRgb = (color: Color): RGBColor => {
  if ("r" in color) {
    // It's already an RGBColor
    return color
  } else if ("c" in color) {
    // It's a CMYKColor, convert to RGB
    return CmykToRgb(color)
  } else {
    // It's an HSLColor, convert to RGB
    return HslToRgb(color)
  }
}
